import { TLocale } from '@internal/utils/machine/i18n/TLocale';
import { availableLocales } from './availableLocales';
import { exposedLocales } from './exposedLocales';

export const isValidLocale = (locale: string | undefined): locale is TLocale =>
    Boolean(locale && availableLocales.includes(locale as TLocale));

export const isValidExposedLocale = (
    locale: string | undefined,
): locale is TLocale =>
    Boolean(locale && exposedLocales.includes(locale as TLocale));
